module.exports = __webpack_public_path__ + "static/media/47.51993ea8.svg";